@if (title) {
<div class="-menu-navigator">
  <app-link class="-title" (click)="closeMenu()">
    <span class="-icon-container"><icon icon="l_left_ankle"></icon></span>{{ title }}</app-link
  >
</div>
}
<div class="-menu-category">
  <div class="-default-category-menus" (mouseenter)="onMouseEnter()" (mouseleave)="onMouseLeave()">
    @for (category of products; track category; let index = $index; let isFirst = $first) {
      <div class="-default-category-menu" [ngClass]="{'-active-first': isFirst}">
        <app-link>{{ category.title }}</app-link>
        <div class="-menu-items-container">
          @for (item of category.children; track item) {
            <app-link [to]="item.path" [ngClass]="{'-first': isFirst, '-last': isLast}">
              <menu-item-card [name]="item.title" [description]="item.description" [icon]="item.icon"></menu-item-card>
            </app-link>
          }
        </div>
      </div>
    }
  </div>
  @if (specialMenuPath && specialMenuTitle) {
    <div class="-special-category-menu">
      <app-link [to]="specialMenuPath">{{specialMenuTitle}}</app-link>
    </div>
  }
</div>
